export type MuseumDataType = {
  title: string;
  subTitle?: string;
  brief: string;
  imgSrc: string;
};

export const SOLUTION_CARD_DATA: MuseumDataType[] = [
  {
    title: '策展为核心',
    subTitle: '让场馆灵起来',
    brief: '提供多主题展览空间，千馆千面、灵活策展，打造“永不落幕”的元宇宙场馆',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/ll3fkef9_419653.png',
  },
  {
    title: '馆藏为基础',
    subTitle: '让藏品走出来',
    brief: '多路径帮助实现批量化藏品建模，建设保护与展示功能并存的藏品库',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/web/index/ll4sy5j7_362499.png',
  },
  {
    title: '教育为目的',
    subTitle: '让观众融进去',
    brief: '打破时空限制，感受元宇宙研学，满足用户多样化的参观需求',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/ll3fkkbu_427306.png',
  },
];

export const SWIPE_CARD_DATA: MuseumDataType[] = [
  {
    title: '策展为核心：让场馆灵起来',
    brief: '提供多主题展览空间，千馆千面、灵活策展，打造“永不落幕”的元宇宙场馆',
    imgSrc: `https://static.fuxi.netease.com/yaotai/portal/index/ll3fkef9_419653.png`,
  },
  {
    title: '馆藏为基础：让藏品走出来',
    brief: '多路径帮助实现批量化藏品建模，建设保护与展示功能并存的藏品库',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/web/index/ll4sy5j7_362499.png',
  },
  {
    title: '教育为目的：让观众融进去',
    brief: '打破时空限制，感受元宇宙研学，满足用户多样化的参观需求',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/ll3fkkbu_427306.png',
  },
];

export const TAB_CARD_DATA: MuseumDataType[] = [
  {
    title: '定制多主题展览空间',
    brief:
      '提供多主题展览空间，支持场景定制，策展方可以通过空间设计定制原创展馆，充分满足不同博物馆定位、理念，实现千馆千面、灵活策展。',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/web/index/ll4vs444_119570.png',
  },
  {
    title: '切身体验数字化藏品',
    brief:
      '通过网易伏羲自研AI扫描、网易游戏美术建模以及网易伏羲有灵美术平台灵活用工服务，实现批量化藏品建模，通过元宇宙交互设计，让参观者亲身使用不同的藏品。',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/web/index/ll4vs443_119570.png',
  },
  {
    title: '多人在线参观、实时互动',
    brief:
      '支持多人同时在线、同屏互动，参观者可以随时随地一键进入元宇宙博物馆，借助个性化的专属虚拟形象，通过私信、弹幕、语音聊天等功能，与其他线上参观者实时交流分享、灵活互动。',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/web/index/ll4vs442_119570.png',
  },
];

export const SCENE_CARD_DATA: MuseumDataType[] = [
  {
    title: '博物馆展览',
    brief: '帮助博物馆实现线上+线下双阵地联动，带来不一样的展览可能，最大限度提升影响力。',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/llab7cx8_355944.png',
  },
  {
    title: '博物馆研学',
    brief: '在元宇宙数字空间中，实现极具互动性和趣味性的在线研学，用科技推动教育发展。',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/llab7cx7_355944.png',
  },
  {
    title: '博物馆品牌合作',
    brief: '为现实博物馆提供元宇宙场景权益，打破馆内空间、内容限制，实现品牌空间自由布置。',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/llab7cx6_355944.png',
  },
  {
    title: '博物馆数字藏品出售',
    brief: '用户可二创虚拟藏品，数字指纹、实体藏品上链，进行NFT发售，实现数字藏品商业化。',
    imgSrc: 'https://static.fuxi.netease.com/yaotai/portal/index/llab7cx5_355944.png',
  },
];
